/*
  Scroll reveal for the ccp-* sections.

  Two rules drive the design of this file:

  1. Nothing is hidden by CSS alone. The stylesheet only hides a reveal
     target when <html> carries .ccp-motion, and that class is added here,
     at runtime. If this script never runs — JS disabled, a parse error, a
     crawler — the page renders fully visible instead of blank. Hiding
     content in CSS and revealing it with JS is the usual way these
     libraries make a page disappear for the people least able to fix it.

  2. Anyone who has asked for reduced motion never gets the class at all,
     so there is nothing to animate and nothing to un-animate.

  The hero is deliberately not a reveal target: it holds the LCP image, and
  starting it at opacity 0 would push Largest Contentful Paint out by the
  length of the animation.
*/
(function () {
  if (window.__ccpRevealReady) return;
  window.__ccpRevealReady = true;

  var root = document.documentElement;

  function start() {
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) return;

    root.classList.add('ccp-motion');

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('ccp-revealed');
          // One-shot: released as soon as it has played, so scrolling back
          // up does not re-run it and the observer empties out.
          observer.unobserve(entry.target);
        }
      },
      {
        // Fire a little before the element reaches the bottom edge, so the
        // motion finishes about when it settles into view.
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08
      }
    );

    var targets = document.querySelectorAll('[data-ccp-reveal]');
    for (var i = 0; i < targets.length; i++) observer.observe(targets[i]);

    // Sections added in the theme editor after load.
    document.addEventListener('shopify:section:load', function (event) {
      var added = event.target.querySelectorAll('[data-ccp-reveal]');
      for (var j = 0; j < added.length; j++) observer.observe(added[j]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
